module.exports = __webpack_public_path__ + "img/watch_bg.dfa05d07.png";